module.exports = __webpack_public_path__ + "img/bluesky3100_20.1870eabc.jpg";